

































































































































































































    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import TablePager from '@/components/TablePager.vue';
    import TableSortEventArgs from '@/types/TableSortEventArgs';
    import PagerOptions, { InitPagerOptions } from '@/types/PagerOptions';
    import SortOptions from '@/types/SortOptions';
    import EntityReference from '@/types/EntityReference';
    import { BButton, BContainer, BRow, BCol, BCard, BCardBody, BCardFooter, BAvatar } from 'bootstrap-vue';
    import ProjectFilterOptions from '@/types/ProjectFilterOptions';
    import Configuration from '@/types/Configuration';
    import InlineSvg from 'vue-inline-svg';
    import AvatarUtils from '@/types/AvatarUtils';
    import DateTime from '@/types/DateTime';
    import AxiosService from '@/services/axiosService';
    import i18n from '../i18n';

    @Component({
        components: {
            'b-container': BContainer,
            'b-row': BRow,
            'b-col': BCol,
            'b-card': BCard,
            'b-card-body': BCardBody,
            'b-card-footer': BCardFooter,
            'b-avatar': BAvatar,
            'table-pager': TablePager,
            'b-btn': BButton,
            'inline-svg': InlineSvg
        }
    })
	export default class ProjectCardList extends Vue {
        @Prop() refresh!: boolean
        @Prop() filter!: ProjectFilterOptions

        projects: ProjectListItem[] = [];
        listOptions: ProjectListOptions = {
            filter: this.filter,
            pagerOptions: {
                page: 1,
                pageSize: Configuration.DefaultPageSize,
                pageCount: 1,
                rowCount: 0,
                rowStart: 0,
                rowEnd: 0
            },
            sortOptions: {
                sortBy: 'sequenceId',
                sortDirection: Configuration.SortDirectionAscending
            }
        };
        isBusy = false;
        apiAccessToken = this.$store.state.apiAccessToken;

        @Watch('refresh')
        refreshList(newVal: boolean) {
            if (newVal) {
                this.loadProjects();
            }
        }

        @Watch('filter')
        filterList(newVal: ProjectFilterOptions) {
            this.listOptions.filter = newVal;
            this.listOptions.pagerOptions.page = 1;
        }

        mounted() {
            this.isBusy = false;
            this.apiAccessToken = this.$store.state.apiAccessToken;
            this.loadProjects();
        }

        async loadProjects() {
            try {
                const response = await AxiosService.request<ServerData>({
                    url: `projectsadministration/cardlist`,
                    method: 'POST',
                    data: this.listOptions
                });

                this.projects = response.data.records ?? [];
                this.listOptions.pagerOptions = InitPagerOptions(response.data.totalRecordCount, response.data.pageCount, this.listOptions.pagerOptions.page, this.listOptions.pagerOptions.pageSize);
            }
            catch (error) {
                if (error.response) {
                    switch (error.response.status) {
                        case 404:
                            return this.$router.push(`/${i18n.locale}/notfound`);
                        case 403:
                            return this.$router.push(`/${i18n.locale}/accessdenied`);
                        default:
                            return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                    }
                }
            }
            finally {
                this.isBusy = false;
                this.$emit('load-complete')
            }
        }

        editProject(id: string) {
             this.$emit('project-selected', id);
        }

        deleteProject(id: string) {
            this.$bvModal.msgBoxConfirm(this.$t('modal.confirmProjectDeleteMessage') as string, {
                title: this.$t('modal.confirmProjectDeleteTitle') as string,
                centered: true,
                buttonSize: 'sm',
                okTitle: this.$t('modal.confirmOkTitle') as string,
                cancelTitle: this.$t('modal.confirmCancelTitle') as string
            })
            .then(value => {
                if (value) {
                    try {
                        AxiosService.request<ServerData>({
                            url: `projectsadministration?id=${id}`,
                            method: 'DELETE'
                        });

                        this.$root.$bvToast.toast(this.$t('toaster.projectDeleted') as string, {
                            title: this.$t('toaster.deleteProjectTitle') as string,
                            autoHideDelay: Configuration.ToasterAutoHideDelay,
                            appendToast: true,
                            variant: Configuration.ToasterVariantSuccess,
                            toaster: Configuration.ToasterPosition
                        });
                        this.loadProjects();
                    }
                    catch (error) {
                        if (error.response) {
                            switch (error.response.status) {
                                case 404:
                                    return this.$router.push(`/${i18n.locale}/notfound`);
                                case 403:
                                    return this.$router.push(`/${i18n.locale}/accessdenied`);
                                default:
                                    return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                            }
                        }
                    }
                    finally {
                        this.isBusy = false;
                    }
                }
            })
            .catch(error => {
                console.error(error);
            });
        }

        onChangePage(page: number) {
            this.listOptions.pagerOptions.page = page;
            this.loadProjects();
        }

        onChangePageSize(pageSize: number) {
            this.listOptions.pagerOptions.pageSize = pageSize;
            this.listOptions.pagerOptions.page = 1;
            this.loadProjects();
        }

        onSortChanged(e: TableSortEventArgs) {
            this.listOptions.sortOptions.sortBy = e.sortBy;
            this.listOptions.sortOptions.sortDirection = e.sortDesc ? -1 : 1;
            this.loadProjects();
        }

        addNewProject() {
            return;
        }

        getProjectInitials(name: string) {
            return AvatarUtils.getUserInitials(name);
        }

        getColorFromName(name: string) {
            return AvatarUtils.getColorFromText(name);
        }

        getLocalDate(dateTime: Date) {
            return DateTime.toLocal(dateTime, DateTime.formats.date);
        }
	}

	interface ServerData {
        records: ProjectListItem[];
        totalRecordCount: number;
        pageCount: number;
	}

    interface ProjectListItem {
        id: string;
        sequenceId: number;
        name: string;
        client: EntityReference;
        start: Date;
        end: Date;
        description: string;
        isActive: boolean;
        actions: string;
    }    

    interface ProjectListOptions {
        filter: ProjectFilterOptions;
        pagerOptions: PagerOptions;
        sortOptions: SortOptions;
    }
